<div class="flex items-center w-full leading-[24px] mb-12">
  <div class="text-ellipsed w-full font-medium text-primary">Add Option</div>
  <button (click)="onAddTag()" class="btn-close">
    <mat-icon svgIcon="icon_add_32" />
  </button>
</div>

<div class="flex flex-col flex-nowrap w-full" cdkDropList (cdkDropListDropped)="onDropTag($event)">
  @for (tag of tags; track trackByValueFn(index, tag); let index = $index) {
    <div
      class="flex flex-nowrap gap-8 items-center px-2 h-32 rounded-2 hover:bg-overlay-light-background"
      cdkDrag
      cdkDragPreviewClass="drag-list-preview"
    >
      <div cdkDragHandle class="drag-handle">
        <mat-icon svgIcon="icon_drag_8" />
      </div>
      <span cdkDragHandle [blazeTooltip]="tag.value" class="tag-value grow cursor-pointer">
        <blaze-inplace-edit
          #editTagValue
          [value]="tag.value"
          [commitOnBlur]="true"
          (committed)="onTagValueEdited($event, index)"
          (cancelled)="onTagValueEditCanceled()"
        >
          <span
            inplace-display
            class="text-ellipsed justify-self-start px-6 py-4 w-fit rounded-full max-w-full block overflow-hidden text-ellipsis"
            [ngStyle]="{ color: tag.foregroundColor, backgroundColor: tag.backgroundColor }"
            (click)="onEditTag(index, editTagValue)"
            >{{ tag.value }}</span
          >
        </blaze-inplace-edit>
      </span>
      <div class="ml-auto flex items-center gap-8">
        <blaze-color-picker
          [color]="tag.foregroundColor"
          (colorChange)="onTagColorChange($event, 'foregroundColor', index)"
        />
        <blaze-color-picker
          [color]="tag.backgroundColor"
          (colorChange)="onTagColorChange($event, 'backgroundColor', index)"
        />
        <mat-icon
          class="bd-btn-icon"
          svgIcon="icon_trash_16"
          (click)="onRemoveTag($event, index)"
        />
      </div>
    </div>
  }
</div>
